<main>
    <section class="form-wrapper">
        <section class="step">
            <form [formGroup]="form" class="form">

                <div class="section section--two-1">

                    <mat-form-field appearance="outline" class="Input Input--select Input--suffix"
                        [class.Input--readonly]="form.disabled">
                        <mat-label>Unidad</mat-label>
                        <input type="text" matInput formControlName="plate">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="Input" [class.Input--readonly]="form.disabled">
                        <mat-label>VIN</mat-label>
                        <input type="text" matInput formControlName="vin">
                    </mat-form-field>

                </div>

                <div class="section section--two-2">

                    <mat-form-field appearance="outline" class="Input" [class.Input--errors]="
            secondFormHasError('acountable', 'required') ||
            secondFormHasError('acountable', 'pattern')
        " [class.Input--readonly]="form.disabled">

                        <mat-label>Persona que realizará el servicio de rebalanceo</mat-label>
                        <input type="text" matInput formControlName="acountable">

                        @if (secondFormHasError('acountable', 'required')) {
                        <mat-error class="ErrorMessage">El responsable es obligatorio</mat-error>
                        }

                        @if (secondFormHasError('acountable', 'pattern')) {
                        <mat-error class="ErrorMessage">El nombre solo debe contener letras</mat-error>
                        }
                    </mat-form-field>

                </div>

                <div class="section section--two-3">

                    <mat-form-field appearance="outline" class="Input"
                        [class.Input--errors]="secondFormHasError('date', 'required')"
                        [class.Input--readonly]="form.disabled">
                        <mat-label>Fecha</mat-label>
                        <input matInput [matDatepicker]="date_two" [min]="oldDate" readonly formControlName="date">
                        <mat-datepicker-toggle matIconSuffix [for]="date_two"></mat-datepicker-toggle>
                        <mat-datepicker #date_two></mat-datepicker>

                        @if (secondFormHasError('date', 'required')) {
                        <mat-error class="ErrorMessage">La fecha es obligatoria</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="Input"
                        [class.Input--errors]="secondFormHasError('hour', 'required') || secondFormHasError('hour', 'errorHour')"
                        [class.Input--readonly]="form.disabled">
                        <mat-label>Hora</mat-label>
                        <input type="time" matInput formControlName="hour">

                        @if (secondFormHasError('hour', 'required')) {
                        <mat-error class="ErrorMessage">La hora es obligatoria</mat-error>
                        }

                        @if (secondFormHasError('hour', 'errorHour')) {
                        <mat-error class="ErrorMessage">La hora es menor a la hora ingresada en el paso 1
                            ({{rebalance!.steps[0].data.hour }})</mat-error>
                        }
                    </mat-form-field>
                </div>

                <div class="section section--two-4">

                    <label>Certifico que la unidad se ha apagado y el %SOC esta en Cero</label>
                    <mat-radio-group color="primary" formControlName="soc_zero"
                        [class.Input--readonly]="form.disabled">
                        <mat-radio-button [checked]="form.get('soc_zero')?.value" [value]="true">Sí
                        </mat-radio-button>
                        <mat-radio-button [checked]="!form.get('soc_zero')?.value" [value]="false">No
                        </mat-radio-button>
                    </mat-radio-group>
                </div>

                <div class="section section--two-5">

                    <div class="section__upload">
                        <app-button color="green" [hasIcon]="true" [isFull]="true"
                            (clicked)="rear_mobile_camera.click()">
                            Tomar foto
                            <app-icon appIcon [icon]="EIcons.photo_camera" iconSize="normal"
                                [iconMoveTopToBotton]="3" />
                        </app-button>

                        <input type="file" style="display: none;" #rear_mobile_camera accept="image/*" capture="camera"
                            (change)="setFiles($event, files)" />

                        <app-button color="green" [hasIcon]="true" (clicked)="files.click()">
                            Subir foto
                            <app-icon appIcon [icon]="EIcons.publish" iconSize="normal" [iconMoveTopToBotton]="3" />
                        </app-button>

                        <input type="file" style="display: none;" #files accept="image/*"
                            (change)="setFiles($event, files)">
                    </div>

                    @if (previewImage()) {
                    <div class="section__preview">
                        <img [src]="previewImage()" alt="rebalancing preview">
                    </div>
                    }
                </div>

                <div class="section section--three-4">
                    <mat-form-field appearance="outline" class="Input Input--textarea"
                        [class.Input--readonly]="form.disabled">
                        <mat-label>Observaciones</mat-label>
                        <textarea matInput formControlName="obs" rows="3"></textarea>
                    </mat-form-field>
                </div>

                <footer>
                    <app-button [color]="'red'" [isFull]="true" (clicked)="resetRebalancing()">Anular rebalanceo
                    </app-button>
                    <app-button [isFull]="true" (clicked)="save()" [isDisabled]="form.invalid">
                        Guardar
                    </app-button>
                </footer>
            </form>
        </section>
    </section>
</main>